module.exports = __webpack_public_path__ + "img/sb-small.50b1de83.png";